// Place a river label "in line" with its river: snap the hand-picked
// anchor onto the nearest point of the extracted centerline and return
// the local bearing as a CSS rotation, normalized to a readable range
// (never upside down). Longitudes are cos(lat)-scaled so the angle
// matches what the Mercator screen shows.

export function riverLabelPlacement(multiline, anchor) {
  const cosLat = Math.cos((anchor.lat * Math.PI) / 180);
  let best = null;
  for (const line of multiline ?? []) {
    for (let i = 0; i < line.length - 1; i++) {
      const [x1, y1] = line[i], [x2, y2] = line[i + 1];
      const dx = (x2 - x1) * cosLat, dy = y2 - y1;
      const len2 = dx * dx + dy * dy;
      // projection of the anchor onto the segment, clamped to it
      const t = len2 === 0 ? 0 : Math.max(0, Math.min(1,
        (((anchor.lng - x1) * cosLat) * dx + (anchor.lat - y1) * dy) / len2));
      const px = x1 + (x2 - x1) * t, py = y1 + (y2 - y1) * t;
      const d = ((px - anchor.lng) * cosLat) ** 2 + (py - anchor.lat) ** 2;
      if (!best || d < best.d) best = { d, px, py, dx, dy };
    }
  }
  if (!best) return { lat: anchor.lat, lng: anchor.lng, angle: 0 };
  // screen angle: y grows downward, latitude upward
  let angle = (Math.atan2(-best.dy, best.dx) * 180) / Math.PI;
  if (angle > 90) angle -= 180;
  if (angle < -90) angle += 180;
  return { lat: best.py, lng: best.px, angle: Math.round(angle) || 0 };
}
